/**
 * Utility-account READ endpoint — request schema + wire types for the
 * read-only accounts index grid (Places Utilities tab, place-filtered; reusable
 * org-wide). Plain RLS-scoped read: the Hono handler pages the
 * `place_utility_account_index` view past PostgREST's 1,000-row cap with a
 * keyset cursor (fetchAllKeyset) through the per-request user client, so org
 * RLS authorizes. Heavy detail (readings) stays on the per-account reads.
 *
 * Shared by the API handler (response construction) and the web index hook
 * (unwrap target) so the two cannot drift. Template: expensesReads.ts.
 */
import { z } from "zod";
/** Query params for GET /orgs/:orgId/accounts/index. */
export const utilityAccountIndexQuerySchema = z.object({
    placeId: z.string().uuid().optional(),
    domain: z.enum(["energy", "water", "waste"]).optional(),
});
//# sourceMappingURL=placeUtilityAccountReads.js.map